// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"237":"pages","466":"errors","597":"projects","662":"videoconference"}[chunkId] || chunkId) + "." + {"193":"592cb453","237":"67e7ad31","247":"1abb060d","342":"6512528f","466":"2c255800","482":"70a13ab3","506":"be59073c","597":"e8d898fa","662":"46c4a19c","701":"a902ed43"}[chunkId] + ".js";
};